import { gql } from "@apollo/client";

export const UPDATE_COMMISSARY_ORDER_STATUS = gql`
  mutation UpdateCommissaryOrderStatus(
    $id: Int!
    $status: String!
    $organizer_notes: String
    $rejection_reason: String
    $fulfilled_at: timestamptz
    $updated_at: timestamptz!
  ) {
    update_order_commissary_by_pk(
      pk_columns: { id: $id }
      _set: {
        status: $status
        organizer_notes: $organizer_notes
        rejection_reason: $rejection_reason
        fulfilled_at: $fulfilled_at
        updated_at: $updated_at
      }
    ) {
      id
      status
    }
  }
`;

export const CREATE_COMMISSARY_ORDER = gql`
  mutation CreateCommissaryOrder(
    $event_id: Int!
    $vendor_id: Int!
    $user_id: Int
    $notes: String
    $subtotal: Int!
    $tax: Int!
    $total: Int!
    $items: jsonb!
    $sms_notify: Boolean!
  ) {
    insert_order_commissary_one(
      object: {
        event_id: $event_id
        vendor_id: $vendor_id
        user_id: $user_id
        status: "pending"
        notes: $notes
        subtotal: $subtotal
        tax: $tax
        total: $total
        items: $items
        sms_notify: $sms_notify
      }
    ) {
      id
      status
      subtotal
      total
      created_at
    }
  }
`;
